export const REEFER_TYPOGRAPHY_FONT_WEIGHT_SEMIBOLD = 600;
export const REEFER_TYPOGRAPHY_FONT_WEIGHT_REGULAR = 400;
